import React, { useState } from "react";
import Layout from "../../Common/Layout";

import UpdateMasterClient from "./UpdateMasterClient";
import UpdateCrd from "./UpdateCrd";
import UpdateCdd from "./UpdateCdd";
import UpdateGateentries from "./UpdateGateentries";
import UpdateDeliveryorder from "./UpdateDeliveryorder";
import UpdateKataSlips from "./UpdateKataSlips";


const UpdateData = () => {
  const [updateType, setUpdateType] = useState("");

  return (
    <Layout>
      <div
        className="container d-flex justify-content-center align-items-center"
        style={{ minHeight: "10vh", width: "30rem" }}
      >
        <select
          className="form-select"
          value={updateType}
          onChange={(e) => setUpdateType(e.target.value)}
        >
          <option value="">-- Select Data To Update --</option>
          <option value="master-client">Master Client</option>
          <option value="crd">CRD</option>
          <option value="cdd">CDD</option>
          <option value="gateentries">Gate Entries</option>
          <option value="kataslip">Kata Slip</option>
          <option value="deliveryorder">Delivery Order</option>
        </select>
      </div>

      {updateType === "master-client" && <UpdateMasterClient />}
      {updateType === "crd" && <UpdateCrd />}
      {updateType === "cdd" && <UpdateCdd />}
      {updateType === "gateentries" && <UpdateGateentries />}
      {updateType === "kataslip" && <UpdateKataSlips />}
      {updateType === "deliveryorder" && <UpdateDeliveryorder />}
    </Layout>
  );
};

export default UpdateData;
